import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';

const position = (): Partial<GridColDef> => ({
  field: 'position',
  headerName: 'Position',
  width: 150,
  renderCell: (params) => `#${params.row.position}`,
  sortable: true,
});

const company = (): Partial<GridColDef> => ({
  field: 'company',
  headerName: 'Company',
  width: 200,
  renderCell: (params) => params.row.company ?? '-',
});

const contact = (): Partial<GridColDef> => ({
  field: 'contact',
  headerName: 'Contact',
  width: 200,
  renderCell: (params) => params.row.contact ?? '-',
});

const phoneNumber = (): Partial<GridColDef> => ({
  field: 'phoneNumber',
  headerName: 'Phone number',
  width: 180,
  renderCell: (params) => params.row.phoneNumber ?? '-',
});

const status = (): Partial<GridColDef> => ({
  field: 'status',
  headerName: 'Status',
  width: 160,
  renderCell: (params) => {
    if (params.row.status === 'Active') return 'Active';
    if (params.row.status === 'Inactive') return 'Inactive';
    return '-';
  },
  sortable: true,
});

const lastUsed = (): Partial<GridColDef> => ({
  field: 'lastUsed',
  headerName: 'Last Used',
  width: 300,
  renderCell: (params) => params.row.lastUsed ?? '-',
});

const actions = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, row: any) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  width: 100,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        openMenu?.(e, params.row);
      }}
    >
      <IcDotSpread />
    </IconButton>
  ),
});

export const towingCompaniesCols = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, row: any) => void,
) => {
  return {
    position,
    company,
    contact,
    phoneNumber,
    status,
    lastUsed,
    actions: () => actions(openMenu),
  };
};
